export const careGiverHealthCareDetailQuery = `query CaregiverHealthCareDetail(
    $externalSourceName: String!,
    $postalCode: String!,
    $packageIds: [String!]
) {
    caregiverHealthCareDetail(
        externalSourceName: $externalSourceName,
        postalCode: $postalCode,
        packageIds: $packageIds
    ) {
        searchId
        externalSourceName
        name
        careType
        distanceToPolicyHolderInKilometers
        policyPolicyDetails {
            contractStatus
            contractNumber
        }
    }
}
`;
